import styled from 'styled-components';
import { formatPrice } from '../../../utils/formatter/formatPrice.util';

interface IPriceHelperTextProps {
  price: number;
}

export const PriceHelperText = ({ price }: IPriceHelperTextProps) => {
  return <Price>{`₩ ${formatPrice(price * 10000) || 0}원`}</Price>;
};

const Price = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;
